import React from 'react'
import {useState,useEffect} from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});
const Testing = () => {
  const classes = useStyles();
    const url = 'https://api.rootnet.in/covid19-in/stats/testing/history'

    const [data, setData] = useState([])
  
    useEffect(() => {
    
      fetch(url)
      .then(response => response.json())
      .then(data => setData(data.data));
      
    }, [])
  
    const renderTable = () => {
      return data.map(data => {
        return (
          <TableRow>
        <TableCell align="left">{data.day}</TableCell>
        <TableCell align="right">{data.totalSamplesTested}</TableCell>
        <TableCell align="right">{data.totalPositiveCases}</TableCell>
        <TableCell align="right">
        <a href={data.source}>{data.source}</a>
        </TableCell>
        </TableRow>
        )
      })
    }
    return (
        <div className="p-5">
        <h2 className="text-center mb-3">India: COVID Testing Updates</h2>
        <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>  
          <TableCell align="left"><h4>Date</h4></TableCell>
          <TableCell align="right"><h4>Total Tested Sample</h4></TableCell>
          <TableCell align="right"><h4>Positive Cases</h4></TableCell>
          <TableCell align="right"><h4>Source</h4></TableCell>
       
          </TableRow>
        </TableHead>
        <TableBody>
        {renderTable()}
        </TableBody>
      </Table>
    </TableContainer>
        
    </div>
    )
}

export default Testing
